import React, { useContext } from "react";

import AreaIcon from "../areaIcon/AreaIcon";

import WheelSizeContext from "../../contexts/WheelSizeContext";
import LifeAreasContext from "../../contexts/LifeAreasContext";

import lifeAreasData from "../../resources/lifeAreas";

import style from "./IconsWheel.module.css";

type IconsWheelProps = {
  wheelRotation: number;
  disabled: boolean;
  onTap: (key: string) => void;
};

const IconsWheel = ({ wheelRotation, disabled, onTap }: IconsWheelProps) => {
  const { lifeAreas: areas } = useContext(LifeAreasContext);
  const angleOffset = -90;
  const wheelSize = useContext(WheelSizeContext);
  const radius = wheelSize / 2;
  const iconContainerSize = 64;

  const renderAreaIcon = (areaKey: string, index: number) => {
    const theta = (Math.PI * 2) / areas.keys.length;
    const angle = theta * index + angleOffset * (Math.PI / 180);
    const left =
      radius * Math.cos(angle) + wheelSize / 2 - iconContainerSize / 2;
    const top =
      radius * Math.sin(angle) + wheelSize / 2 - iconContainerSize / 2;
    // const areaRotation = (360 / areas.keys.length) * index;
    return (
      <AreaIcon
        key={areaKey}
        area={lifeAreasData[areaKey]}
        style={{ left, top }}
        rotate={-wheelRotation}
        onTap={() => onTap(areaKey)}
        disabled={disabled}
      />
    );
  };
  return (
    <div
      className={style.container}
      style={{
        width: wheelSize,
        height: wheelSize,
      }}
    >
      {areas.keys.map(renderAreaIcon)}
    </div>
  );
};

export default IconsWheel;
